import BCAppOrgAdmin from 'assets/images/braincare-user/app-org-admin.png';
import BCAppUserAdmin from 'assets/images/braincare-user/app-user-admin.png';
import BCAppLogAdmin from 'assets/images/braincare-user/app-log-admin.png';
import mobileDeviceIcon from 'assets/images/braincare-user/device.svg';

export const BRAINCARE_USER_ACCOUNTS_ADMIN = 'BC_ACCOUNTS_ADMIN';
export const BRAINCARE_USER_USERS_ADMIN = 'BC_USERS_ADMIN';
export const BRAINCARE_USER_DEVICE_SUPPORT = 'BC_DEVICE_SUPPORT';

export const braincareApps = [
  {
    id: 0,
    href: '/braincare/users',
    image: BCAppUserAdmin,
    name: 'applications.braincare.user-admin',
    permission: BRAINCARE_USER_USERS_ADMIN,
  },
  {
    id: 1,
    href: '/braincare/organizations',
    image: BCAppOrgAdmin,
    name: 'applications.braincare.org-admin',
    permission: BRAINCARE_USER_ACCOUNTS_ADMIN,
  },
  {
    id: 2,
    href: '/braincare/admin-mobile-devices',
    image: mobileDeviceIcon,
    name: 'applications.braincare.admin-mobile-devices',
    permission: BRAINCARE_USER_ACCOUNTS_ADMIN,
  },
  {
    id: 3,
    href: '/braincare/logs',
    image: BCAppLogAdmin,
    name: 'applications.braincare.log-admin',
    permission: BRAINCARE_USER_ACCOUNTS_ADMIN,
  },
  {
    id: 4,
    href: '/braincare/reports',
    image: BCAppOrgAdmin,
    name: 'applications.braincare.reports-admin',
    permission: BRAINCARE_USER_ACCOUNTS_ADMIN,
  },
];
